import * as React from "react";
import * as toastr from "toastr";
import { DeleteDatabaseAsync } from "source/app/infrastructure/Data/MotwIndexedDb";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import WorkboxCache from "source/app/services/WorkboxCache/WorkboxCache";
import { BookOfMindVoicePicker } from "source/app/presentation/Header/Tools/GameOptions/BookOfMindVoicePicker";
import { GetMenuItemStyleClass, labelStyleClass } from "./PlayerMenuStyles";
import { MenuItem } from "./MenuItem";
import { CompactSystemDateOffset } from "./Preferences";

export function GameOptionsMenu({
    isOpen,
    onToggle,
    onSelect,
}: {
    isOpen: boolean;
    onToggle: () => void;
    onSelect: () => void;
}) {
    return (
        <div
            className={StyleClassAuto({
                borderTop: "1px solid rgba(255, 255, 255, 0.12)",
                marginTop: "6px",
                paddingTop: "6px",
            })}
        >
            <Hyperlink
                whenClicked={onToggle}
                classes={GetMenuItemStyleClass()}
            >
                <Glyphicon icon={EGlyphicon.cog} />
                <span className={labelStyleClass}>Game options</span>
                <span
                    className={StyleClassAuto({
                        float: "right",
                        opacity: 0.65,
                    })}
                >
                    <Glyphicon
                        icon={
                            isOpen
                                ? EGlyphicon["chevron-up"]
                                : EGlyphicon["chevron-down"]
                        }
                    />
                </span>
            </Hyperlink>
            {isOpen && (
                <div
                    className={StyleClassAuto({
                        padding: "4px 2px 0 20px",
                        fontSize: "17px",
                    })}
                >
                    <BookOfMindVoicePicker />
                    <CompactSystemDateOffset />
                    <MenuItem
                        onSelect={onSelect}
                        icon={EGlyphicon.erase}
                        label="Clear cache"
                        onClick={ClearCacheAndReload}
                    />
                </div>
            )}
        </div>
    );
}

async function ClearCacheAndReload() {
    toastr.info(`Cache cleared. Reloading page...`);
    const username = localStorage.getItem("username");
    WorkboxCache.Clear();
    localStorage.clear();
    if (username) {
        localStorage.setItem("username", username);
    }
    await DeleteDatabaseAsync();
}
